import styled, { css } from 'styled-components';
import {
  Row,
  Card,
  Space,
  Input,
  Table,
  Typography,
  Select,
  Button,
} from 'antd';

import colors from '../../../../styles/colors';
import * as S from '../styles';

const { Text } = Typography;
const { Option } = Select;

export const StyledColMatriz = styled(S.StyledCol)``;

export const Container = styled(Card)`
  width: 100%;
  height: ${props => (props.height ? '680px' : '100%')};
  border-radius: 2px;
  ${props =>
    props.additional &&
    css`
      .ant-card-body {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 24px 24px 0 24px;
      }
    `}
`;

export const ContainerSearch = styled(Row)``;

export const InputSearch = styled(Input)`
  background: #f2f2f2;
  border-radius: 2px;
  font-size: 14px;
  padding: 4px 11px;
  height: 48px;
  border: none;
`;

export const ContainerContent = styled(Card)`
  width: 100%;
  height: 620px;
  overflow-y: none;
  .ant-card-body {
    padding: 0 !important;
    margin: 0 !important;
  }
`;

export const ContainerTable = styled.div`
  width: 100%;
`;

export const TableList = styled(Table)`
  .ant-table-thead ::before {
    display: none;
  }
  .ant-table-header {
    margin-bottom: 12px !important;
  }

  .ant-table-row.ant-table-row-level-0 {
    height: 28px;
  }

  .ant-table-thead > tr > th {
    border-bottom: 2px solid #cacaca;
    background-color: ${colors.branco};
    color: ${colors.greyText};
    :nth-last-child(-n + 1) {
      border-bottom: none;
    }
  }
  .ant-table-body {
    padding: 0 12px 0 0;
  }
  .ant-table-tbody > tr > td {
    border-bottom: none;
    font-size: 14px;
    color: #828282;
    padding: 0 12px;
  }
`;

export const BoxAcoes = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  .ant-space {
    cursor: pointer;
  }
`;

export const ContainerTitleForm = styled.div`
  width: 56%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

export const AddMatriz = styled(Space)`
  color: ${colors.verde};
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  cursor: pointer;
`;

export const TitleForm = styled(Text)`
  color: ${colors.verde};
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
`;

export const SelectCustom = styled(Select)`
  font-size: 14px;
  line-height: 20px;
  border-radius: 2px;
  color: #828282;
  width: ${props => props.width || 100}%;

  .btnSUy,
  .ant-select-selector,
  div {
    background-color: #f2f2f2 !important;
    font-weight: bold;
    color: #828282;
  }

  .ant-select-clear {
    background-color: #f2f2f2 !important;
    font-weight: bold;
    color: #24a95d;
  }
  .ant-select-single,
  .ant-select-selector,
  .ant-select-selection-item {
    background-color: #f2f2f2 !important;
    color: #828282;
  }

  .ant-tabs .ant-select-selector,
  .ant-tabs-top .ant-select-selector,
  .ant-tabs-card .ant-select-selector {
    background: #f2f2f2;
    border-radius: 2px !important;
  }

  .ant-select-arrow {
    color: #001f2a;
  }
`;

export const OptionCuston = styled(Option)`
  font-size: 14px;
  line-height: 20px;
  color: #828282;
`;

export const ContainerBtn = styled.div`
  margin-top: -60px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  justify-items: center;
  width: 100%;
  height: 100%;
`;

export const BottonCustom = styled(Button)`
  height: 40.35px;
  width: 106px;
  margin-right: ${props => (props.margin ? '13px' : '0')};
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  border-radius: 2px !important;
  border: ${props => (props.cancel ? 'solid 1px #24A95D' : 'none')} !important;
  color: ${props => (props.cancel ? '#24A95D' : '#FFFF')} !important;
  background-color: ${props => props.bgcolor || '#24A95D'} !important;
`;
